/* eslint-disable */

/** unique or primary key constraints on table "argo.attribute_schema_type" */
export enum ArgoAttributeSchemaTypeConstraint {
  /** unique or primary key constraint on columns "type" */
  AttributeSchemaTypePkey = 'attribute_schema_type_pkey'
}

export enum ArgoAttributeSchemaTypeEnum {
  /** App */
  App = 'app',
  /** App Template */
  AppTemplate = 'app_template',
  /** App Type */
  AppType = 'app_type',
  /** Data Element */
  DataElement = 'data_element',
  /** Location */
  Location = 'location',
  /** Material */
  Material = 'material',
  /** Material Class */
  MaterialClass = 'material_class',
  /** Material Model */
  MaterialModel = 'material_model'
}

/** select columns of table "argo.attribute_schema_type" */
export enum ArgoAttributeSchemaTypeSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

/** update columns of table "argo.attribute_schema_type" */
export enum ArgoAttributeSchemaTypeUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Type = 'type'
}

